
function initMaps() {
  const mapElements = Array.from(document.querySelectorAll('[data-map-lat][data-map-lng]'));
  mapElements.forEach((mapElement) => {
    const zoom = parseInt(mapElement.getAttribute('data-map-zoom'), 10) || 15;
    const lat = parseFloat(mapElement.getAttribute('data-map-lat'));
    const lng = parseFloat(mapElement.getAttribute('data-map-lng'));
    const pinTitle = mapElement.getAttribute('data-map-pin-title');
    const center = new window.google.maps.LatLng(lat, lng);

    const mapOptions = {
      zoom,
      center,
      // https://snazzymaps.com/style/151/ultra-light-with-labels
      styles: [{ featureType: 'water', elementType: 'geometry', stylers: [{ color: '#e9e9e9' }, { lightness: 17 }] }, { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 20 }] }, { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }, { lightness: 17 }] }, { featureType: 'road.highway', elementType: 'geometry.stroke', stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }] }, { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 18 }] }, { featureType: 'road.local', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { lightness: 16 }] }, { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#f5f5f5' }, { lightness: 21 }] }, { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dedede' }, { lightness: 21 }] }, { elementType: 'labels.text.stroke', stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }] }, { elementType: 'labels.text.fill', stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { featureType: 'transit', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }, { lightness: 19 }] }, { featureType: 'administrative', elementType: 'geometry.fill', stylers: [{ color: '#fefefe' }, { lightness: 20 }] }, { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }] }],
    };

    const map = new window.google.maps.Map(mapElement, mapOptions);

    if (pinTitle) {
      const marker = new window.google.maps.Marker({
        position: center,
        map,
        title: pinTitle,
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.google && window.google.maps) {
    window.google.maps.event.addDomListener(window, 'load', initMaps);
  }
});
